module.exports = __webpack_public_path__ + "public/images/slider/speaker-8-icon.dc143e0c708e40b9e9a7b9c9836928dc.jpg";